export const HELP_PATH = "/help";

export const isHelpPath = (pathname: string) =>
  pathname === HELP_PATH || pathname.startsWith(`${HELP_PATH}/`);

export const getHelpTopicPath = (id: string) => `${HELP_PATH}/${id}`;

export const LEGACY_HELP_TOPICS: Record<string, string> = {
  "payroll/roster/employees": getHelpTopicPath("payroll/roster"),
  "accounts-payable/emails/attachments": getHelpTopicPath(
    "accounts-payable/emails",
  ),
  overview: getHelpTopicPath("payroll"),
  roster: getHelpTopicPath("payroll/roster"),
  "pay-plans": getHelpTopicPath("payroll/pay-plans"),
  paypacks: getHelpTopicPath("payroll/paypacks"),
  pushpay: getHelpTopicPath("payroll/pushpay"),
};
